<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        :color="color"
        @click="$emit('click')"
    >
        <path class="a" d="M5.96,11.284a5.25,5.25,0,0,1,6.629-.647" />

        <path class="a" d="M3.07,7.822a9.75,9.75,0,0,1,13.165-.029" />

        <path class="a" d="M.75,3.885A14.252,14.252,0,0,1,18.6,3.892" />

        <path
            class="a"
            d="M17.25,20.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
        />

        <line class="a" x1="17.25" y1="18" x2="17.25" y2="15" />

        <path
            class="a"
            d="M23.063,20.683a1.774,1.774,0,0,1-1.587,2.567H13.024a1.774,1.774,0,0,1-1.587-2.567l4.226-8.452a1.774,1.774,0,0,1,3.174,0Z"
        />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'NetworkWarningIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
        color: {
            type: String,
            default: '#000',
        },
    },
}
</script>

<style lang="scss" scoped>
.a {
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
}
</style>
